import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ICollectionChallengeItem } from './list-collection-challenges-response';

export async function listPublicCollectionChallengesApi(
  id: number,
  cursor?: string,
  playable?: boolean,
) {
  const params = { ...(cursor && { cursor }), ...(playable && { playable: '1' }) };
  return getRequest<IAPI<ICollectionChallengeItem[]>>({
    path: `/collections/${id}/challenges`,
    options: Object.keys(params).length > 0 ? { params } : undefined,
  });
}
